module.exports = __webpack_public_path__ + "images/hypothesis-test-15.webp";